import React, { Component } from 'react'

import { CopyToClipboard } from 'react-copy-to-clipboard'
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter'
import { mtb, wt } from './prism'
import Tabs from '../tabs'

import './style.scss'

export default class Code extends Component {
  state = {
    copied: false,
  }

  copyCode() {
    this.setState({ copied: true })
  }

  render() {
    const style = {
      fontFamily: '"Andale Mono", "Ubuntu Mono", monospace',
      whiteSpace: 'pre-wrap',
    }

    return (
      <div className="code">
        {this.props.noTabs ? (
          <div>
            <SyntaxHighlighter
              language={this.props.language}
              codeTagProps={{ style }}
              style={this.props.site === 'mt' ? mtb : wt}
            >
              {this.props.children}
            </SyntaxHighlighter>
            {this.props.children && (
              <CopyToClipboard
                text={this.props.children}
                onCopy={() => this.copyCode()}
              >
                <div
                  className={
                    'code__copy ' + (this.state.copied && 'code__copy--copied')
                  }
                >
                  {this.state.copied ? 'Copied!' : 'Copy'}
                </div>
              </CopyToClipboard>
            )}
          </div>
        ) : (
          <Tabs>
            <div label="HTML">
              <SyntaxHighlighter
                language={this.props.language}
                codeTagProps={{ style }}
                style={this.props.site === 'mt' ? mtb : wt}
              >
                {this.props.children}
              </SyntaxHighlighter>

              {this.props.children && (
                <CopyToClipboard
                  text={this.props.children}
                  onCopy={() => this.copyCode()}
                >
                  <div
                    className={
                      'code__copy ' +
                      (this.state.copied && 'code__copy--copied')
                    }
                  >
                    {this.state.copied ? 'Copied!' : 'Copy'}
                  </div>
                </CopyToClipboard>
              )}
            </div>
            <div label="Vanilla JS" hide={!this.props.js}>
              <SyntaxHighlighter
                language="javascript"
                codeTagProps={{ style }}
                style={this.props.site === 'mt' ? mtb : wt}
              >
                {this.props.js}
              </SyntaxHighlighter>

              {this.props.js && (
                <CopyToClipboard
                  text={this.props.js}
                  onCopy={() => this.copyCode()}
                >
                  <div
                    className={
                      'code__copy ' +
                      (this.state.copied && 'code__copy--copied')
                    }
                  >
                    {this.state.copied ? 'Copied!' : 'Copy'}
                  </div>
                </CopyToClipboard>
              )}
            </div>
            {/* <div label="Angular" disabled={!this.props.angular}>
              <SyntaxHighlighter
                language="ts"
                codeTagProps={{ style }}
                style={this.props.site === 'mt' ? mtb : wt}
              >
                {this.props.angular}
              </SyntaxHighlighter>

              {this.props.angular && (
                <CopyToClipboard
                  text={this.props.angular}
                  onCopy={() => this.copyCode()}
                >
                  <div
                    className={
                      'code__copy ' +
                      (this.state.copied && 'code__copy--copied')
                    }
                  >
                    {this.state.copied ? 'Copied!' : 'Copy'}
                  </div>
                </CopyToClipboard>
              )}
            </div> */}
          </Tabs>
        )}
      </div>
    )
  }
}

Code.defaultProps = {
  mode: 'dark',
  children: 'Insert code here',
  js: false,
  angular: false,
  noTabs: true,
}
